import React from 'react';
import { motion } from 'framer-motion';
import { Printer, FileText } from 'lucide-react';

export default function Printing() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      className="page-container"
    >
      <div className="flex items-center gap-3 mb-6">
        <div className="p-2.5 rounded-xl bg-primary-100 dark:bg-primary-900/30">
          <Printer size={24} className="text-primary-600 dark:text-primary-400" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white font-display">
            Printing
          </h1>
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Manage print jobs and receipts
          </p>
        </div>
      </div>

      <div className="card p-12">
        <div className="flex flex-col items-center justify-center text-center">
          <div className="w-16 h-16 rounded-full bg-gray-100 dark:bg-gray-700 flex items-center justify-center mb-4">
            <FileText size={28} className="text-gray-400 dark:text-gray-500" />
          </div>
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
            Print Queue
          </h3>
          <p className="text-sm text-gray-500 dark:text-gray-400 max-w-md">
            Printing functionality will be available here. You will be able to manage print jobs,
            configure printer settings, and view print history.
          </p>
        </div>
      </div>
    </motion.div>
  );
}
